import { TemplateCategory } from "./types";

export const familiaSuccessoesCategory: TemplateCategory = {
  id: "familia-sucessoes",
  name: "Direito de Família e Sucessões",
  emoji: "👨‍👩‍👧‍👦",
  description: "Documentos de direito de família e sucessões",
  subcategories: [
    {
      id: "direito-familia",
      name: "Direito de Família",
      emoji: "👨‍👩‍👧‍👦",
      templates: [
        {
          id: "acao-divorcio",
          name: "Ação de Divórcio",
          type: "Petição Inicial",
          description: "Modelo para ação de divórcio consensual ou litigioso",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], portador(a) do RG nº [NÚMERO] e CPF nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base nos artigos 226, § 6º da Constituição Federal e artigos 1.571 e seguintes do Código Civil, propor a presente

AÇÃO DE DIVÓRCIO [CONSENSUAL/LITIGIOSO]

em face de [NOME DO CÔNJUGE], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. As partes contraíram matrimônio em [DATA], perante o Cartório de Registro Civil de [LOCAL], conforme certidão anexa.

2. [DESCREVER OS MOTIVOS DO DIVÓRCIO - impossibilidade da vida em comum, se litigioso]

3. [SE CONSENSUAL: As partes chegaram a um acordo quanto à partilha de bens, guarda dos filhos menores e alimentos]

4. [SE HOUVER FILHOS: Do casamento nasceram os seguintes filhos: [NOMES E IDADES]]

5. [REGIME DE BENS E PATRIMÔNIO]

II - DO DIREITO

O artigo 1.571 do Código Civil estabelece que a sociedade conjugal termina pelo divórcio.

[FUNDAMENTAÇÃO ESPECÍFICA CONFORME O CASO]

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do requerido para, querendo, contestar a presente ação;
b) A procedência dos pedidos para decretar o divórcio do casal;
c) [PEDIDOS ESPECÍFICOS: partilha, guarda, alimentos];
d) A condenação do requerido nos ônus da sucumbência.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "acao-guarda",
          name: "Ação de Guarda",
          type: "Petição Inicial",
          description: "Modelo para ação de guarda de menor",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME COMPLETO], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.583 e seguintes do Código Civil e no Estatuto da Criança e do Adolescente, propor a presente

AÇÃO DE GUARDA

em face de [NOME DO OUTRO GENITOR], [QUALIFICAÇÃO], tendo por objeto a guarda do(a) menor [NOME DO MENOR], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente é [RELAÇÃO COM O MENOR] do(a) menor [NOME], nascido(a) em [DATA DE NASCIMENTO].

2. [DESCREVER A SITUAÇÃO ATUAL E OS MOTIVOS PARA O PEDIDO DE GUARDA]

3. O(a) menor encontra-se sob os cuidados do(a) requerente desde [DATA].

4. [DESCREVER AS CONDIÇÕES DO REQUERENTE PARA EXERCER A GUARDA]

5. A guarda pelo(a) requerente atende ao melhor interesse do menor.

II - DO DIREITO

O artigo 1.583 do Código Civil e o artigo 33 do ECA estabelecem os critérios para a guarda de menores, sempre priorizando o melhor interesse da criança.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do requerido;
b) A concessão da guarda do(a) menor em favor do(a) requerente;
c) A fixação de visitas em favor do genitor não guardião;
d) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "acao-alimentos",
          name: "Ação de Alimentos",
          type: "Petição Inicial",
          description: "Modelo para ação de alimentos",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME DO ALIMENTANDO], [QUALIFICAÇÃO], representado(a) por [NOME DO REPRESENTANTE], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base nos artigos 1.694 e seguintes do Código Civil, propor a presente

AÇÃO DE ALIMENTOS

em face de [NOME DO ALIMENTANTE], [QUALIFICAÇÃO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. [DESCREVER O PARENTESCO OU RELAÇÃO ENTRE AS PARTES]

2. O(a) alimentando(a) encontra-se em situação de necessidade, conforme documentos anexos.

3. O(a) requerido(a) possui condições financeiras para prestar alimentos, exercendo a profissão de [PROFISSÃO] e auferindo renda mensal de aproximadamente R$ [VALOR].

4. [DESCREVER AS NECESSIDADES ESPECÍFICAS DO ALIMENTANDO]

II - DO DIREITO

O artigo 1.694 do Código Civil estabelece o dever de prestar alimentos aos parentes necessitados.

O binômio necessidade-possibilidade deve ser observado na fixação dos alimentos.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A concessão de alimentos provisórios;
b) A citação do requerido;
c) A procedência para fixar alimentos definitivos em [PERCENTUAL OU VALOR];
d) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "acao-exoneracao-alimentos",
          name: "Ação de Exoneração de Alimentos",
          type: "Petição Inicial",
          description: "Modelo para ação de exoneração ou revisão de alimentos",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME DO ALIMENTANTE], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.699 do Código Civil, propor a presente

AÇÃO DE [EXONERAÇÃO/REVISÃO] DE ALIMENTOS

em face de [NOME DO ALIMENTANDO], [QUALIFICAÇÃO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. Por força da decisão proferida nos autos nº [NÚMERO DO PROCESSO], o requerente foi condenado ao pagamento de alimentos no valor de [VALOR/PERCENTUAL].

2. [PARA EXONERAÇÃO: Cessaram os motivos que ensejaram a fixação dos alimentos, pois [MOTIVOS]]

3. [PARA REVISÃO: Houve alteração nas condições das partes, especificamente [DESCREVER AS MUDANÇAS]]

4. [DESCREVER A SITUAÇÃO ATUAL DO ALIMENTANTE E/OU ALIMENTANDO]

II - DO DIREITO

O artigo 1.699 do Código Civil permite a revisão ou exoneração de alimentos quando cessarem os motivos que os determinaram.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do requerido;
b) A [EXONERAÇÃO/REVISÃO] dos alimentos fixados;
c) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "acao-regulamentacao-visitas",
          name: "Ação de Regulamentação de Visitas",
          type: "Petição Inicial",
          description: "Modelo para ação de regulamentação de visitas",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME COMPLETO], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.589 do Código Civil e no Estatuto da Criança e do Adolescente, propor a presente

AÇÃO DE REGULAMENTAÇÃO DE VISITAS

em face de [NOME DO GUARDIÃO], [QUALIFICAÇÃO], tendo por objeto a regulamentação das visitas ao(à) menor [NOME DO MENOR], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente é [RELAÇÃO COM O MENOR] do(a) menor [NOME], nascido(a) em [DATA].

2. A guarda do(a) menor foi estabelecida em favor do(a) requerido(a) [FORMA COMO FOI ESTABELECIDA].

3. O(a) requerente tem o direito de visitar o(a) menor, mas não há regulamentação judicial específica.

4. [DESCREVER EVENTUAIS DIFICULDADES OU IMPEDIMENTOS ÀS VISITAS]

5. É necessária a regulamentação para garantir o direito de convivência familiar.

II - DO DIREITO

O artigo 1.589 do Código Civil assegura ao cônjuge separado judicialmente o direito de visitar os filhos menores.

O artigo 19 do ECA garante o direito à convivência familiar.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do requerido;
b) A regulamentação das visitas nos seguintes moldes: [ESPECIFICAR DIAS, HORÁRIOS, FÉRIAS];
c) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "acao-investigacao-paternidade",
          name: "Ação de Investigação de Paternidade",
          type: "Petição Inicial",
          description: "Modelo para ação de investigação de paternidade",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME DO MENOR], [QUALIFICAÇÃO], representado(a) por sua genitora [NOME DA MÃE], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base nos artigos 1.596 e seguintes do Código Civil e na Lei 8.560/92, propor a presente

AÇÃO DE INVESTIGAÇÃO DE PATERNIDADE

em face de [NOME DO SUPOSTO PAI], [QUALIFICAÇÃO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) menor [NOME] nasceu em [DATA], conforme certidão de nascimento anexa.

2. A genitora do(a) menor manteve relacionamento amoroso com o requerido no período de [PERÍODO].

3. [DESCREVER AS CIRCUNSTÂNCIAS DO RELACIONAMENTO E EVIDÊNCIAS DA PATERNIDADE]

4. O requerido se recusa a reconhecer voluntariamente a paternidade.

5. Há indícios suficientes da paternidade que justificam a presente ação.

II - DO DIREITO

O artigo 1.596 do Código Civil estabelece que os filhos têm os mesmos direitos e qualificações.

A Lei 8.560/92 regula a investigação de paternidade dos filhos havidos fora do casamento.

O direito ao reconhecimento da filiação é imprescritível e personalíssimo.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do requerido;
b) A realização de exame de DNA;
c) O reconhecimento da paternidade;
d) A retificação do registro de nascimento;
e) A fixação de alimentos;
f) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "acao-separacao-corpos",
          name: "Ação de Separação de Corpos",
          type: "Petição Inicial",
          description: "Modelo para ação de separação de corpos",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME COMPLETO], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.562 do Código Civil, propor a presente

AÇÃO DE SEPARAÇÃO DE CORPOS

em face de [NOME DO CÔNJUGE], [QUALIFICAÇÃO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. As partes contraíram matrimônio em [DATA], perante o [CARTÓRIO], conforme certidão anexa.

2. [DESCREVER OS MOTIVOS QUE JUSTIFICAM A SEPARAÇÃO DE CORPOS]

3. A convivência tornou-se insuportável, havendo risco à integridade física e moral do(a) requerente.

4. É urgente a separação de corpos para preservar a segurança e dignidade das partes.

5. [SE HOUVER FILHOS: Do casamento nasceram os filhos [NOMES E IDADES]]

II - DO DIREITO

O artigo 1.562 do Código Civil permite a separação de corpos quando a convivência se torna insuportável.

A medida tem caráter cautelar e visa proteger a integridade das partes.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A concessão de liminar para separação imediata de corpos;
b) A citação do requerido;
c) A procedência para confirmar a separação de corpos;
d) [SE NECESSÁRIO: Fixação de alimentos provisórios e guarda dos filhos];
e) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "acao-adocao",
          name: "Ação de Adoção",
          type: "Petição Inicial",
          description: "Modelo para ação de adoção de menor",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DA INFÂNCIA E JUVENTUDE DA COMARCA DE _____________

[NOME DO ADOTANTE], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base nos artigos 39 e seguintes do Estatuto da Criança e do Adolescente, propor a presente

AÇÃO DE ADOÇÃO

tendo por objeto a adoção do(a) menor [NOME DO ADOTANDO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente deseja adotar o(a) menor [NOME], nascido(a) em [DATA].

2. [DESCREVER A SITUAÇÃO DO MENOR: se está sob guarda, em abrigo, etc.]

3. O(a) requerente possui condições materiais e morais para exercer o poder familiar.

4. [DESCREVER A RELAÇÃO ENTRE ADOTANTE E ADOTANDO, SE EXISTIR]

5. A adoção atende ao melhor interesse da criança/adolescente.

6. [SE NECESSÁRIO: Os genitores biológicos consentiram com a adoção]

II - DO DIREITO

O artigo 39 do ECA estabelece que a adoção confere a condição de filho ao adotado.

O artigo 43 exige que a adoção seja sempre precedida de estágio de convivência.

O melhor interesse da criança é o princípio norteador da adoção.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação dos interessados;
b) A realização de estudo psicossocial;
c) O estágio de convivência, se necessário;
d) A procedência para deferir a adoção;
e) A expedição de nova certidão de nascimento;
f) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        }
      ]
    },
    {
      id: "uniao-estavel-casamento",
      name: "União Estável e Casamento",
      emoji: "💑",
      templates: [
        {
          id: "acao-reconhecimento-uniao-estavel",
          name: "Ação de Reconhecimento de União Estável",
          type: "Petição Inicial",
          description: "Modelo para ação de reconhecimento e dissolução de união estável",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME COMPLETO], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.723 do Código Civil, propor a presente

AÇÃO DE [RECONHECIMENTO/RECONHECIMENTO E DISSOLUÇÃO] DE UNIÃO ESTÁVEL

em face de [NOME DO COMPANHEIRO], [QUALIFICAÇÃO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. As partes mantiveram união estável no período de [DATA INÍCIO] a [DATA FIM, SE APLICÁVEL].

2. Durante a convivência, as partes viveram como se casados fossem, com publicidade, continuidade e objetivo de constituir família.

3. [DESCREVER AS CIRCUNSTÂNCIAS DA UNIÃO: convivência, patrimônio comum, etc.]

4. [SE DISSOLUÇÃO: A união se desfez em [DATA] por [MOTIVOS]]

5. [DESCREVER BENS ADQUIRIDOS DURANTE A UNIÃO]

II - DO DIREITO

O artigo 1.723 do Código Civil reconhece como entidade familiar a união estável entre homem e mulher.

A união estável caracteriza-se pela convivência pública, contínua e duradoura com objetivo de constituir família.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do requerido;
b) O reconhecimento da união estável;
c) [SE DISSOLUÇÃO: A dissolução da união estável];
d) A partilha dos bens adquiridos na constância da união;
e) [SE NECESSÁRIO: Fixação de alimentos];
f) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "habilitacao-casamento",
          name: "Habilitação para Casamento",
          type: "Requerimento",
          description: "Modelo para habilitação de casamento",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME DO NUBENTE 1], [QUALIFICAÇÃO], e [NOME DO NUBENTE 2], [QUALIFICAÇÃO], vêm, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base nos artigos 1.525 e seguintes do Código Civil, requerer

HABILITAÇÃO PARA CASAMENTO

pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. Os requerentes pretendem contrair matrimônio e encontram-se habilitados para tanto.

2. [NUBENTE 1] é [ESTADO CIVIL], [IDADE], e não possui impedimentos matrimoniais.

3. [NUBENTE 2] é [ESTADO CIVIL], [IDADE], e não possui impedimentos matrimoniais.

4. [SE MENOR DE 18 ANOS: O(a) nubente [NOME] é menor de idade, mas possui autorização dos pais/responsáveis]

5. [SE NECESSÁRIO: Apresentam os documentos exigidos pelo art. 1.525 do Código Civil]

II - DO DIREITO

O artigo 1.525 do Código Civil estabelece os documentos necessários para habilitação do casamento.

O artigo 1.517 permite o casamento de maiores de 16 anos com autorização.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) O processamento da habilitação para casamento;
b) A publicação dos proclamas;
c) Não havendo impedimentos, a expedição de certidão para celebração do casamento;
d) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        }
      ]
    },
    {
      id: "adocao",
      name: "Adoção",
      emoji: "👶",
      templates: [
        {
          id: "acao-adocao",
          name: "Ação de Adoção",
          type: "Petição Inicial",
          description: "Modelo para ação de adoção de menor",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DA INFÂNCIA E JUVENTUDE DA COMARCA DE _____________

[NOME DO ADOTANTE], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base nos artigos 39 e seguintes do Estatuto da Criança e do Adolescente, propor a presente

AÇÃO DE ADOÇÃO

tendo por objeto a adoção do(a) menor [NOME DO ADOTANDO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente deseja adotar o(a) menor [NOME], nascido(a) em [DATA].

2. [DESCREVER A SITUAÇÃO DO MENOR: se está sob guarda, em abrigo, etc.]

3. O(a) requerente possui condições materiais e morais para exercer o poder familiar.

4. [DESCREVER A RELAÇÃO ENTRE ADOTANTE E ADOTANDO, SE EXISTIR]

5. A adoção atende ao melhor interesse da criança/adolescente.

6. [SE NECESSÁRIO: Os genitores biológicos consentiram com a adoção]

II - DO DIREITO

O artigo 39 do ECA estabelece que a adoção confere a condição de filho ao adotado.

O artigo 43 exige que a adoção seja sempre precedida de estágio de convivência.

O melhor interesse da criança é o princípio norteador da adoção.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação dos interessados;
b) A realização de estudo psicossocial;
c) O estágio de convivência, se necessário;
d) A procedência para deferir a adoção;
e) A expedição de nova certidão de nascimento;
f) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        }
      ]
    },
    {
      id: "sucessoes",
      name: "Sucessões",
      emoji: "📋",
      templates: [
        {
          id: "inventario-judicial",
          name: "Inventário Judicial",
          type: "Petição Inicial",
          description: "Modelo para inventário judicial",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME DO INVENTARIANTE], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base nos artigos 610 e seguintes do Código de Processo Civil, requerer a abertura de

INVENTÁRIO

dos bens deixados por [NOME DO DE CUJUS], [QUALIFICAÇÃO], falecido(a) em [DATA DO ÓBITO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. [NOME DO DE CUJUS] faleceu em [DATA], conforme certidão de óbito anexa.

2. O(a) falecido(a) deixou os seguintes herdeiros: [RELACIONAR OS HERDEIROS COM QUALIFICAÇÃO]

3. O patrimônio deixado pelo(a) de cujus consiste em: [DESCREVER OS BENS]

4. [SE HOUVER TESTAMENTO: O(a) falecido(a) deixou testamento, conforme documento anexo]

5. [INFORMAR SOBRE CÔNJUGE SUPÉRSTITE E REGIME DE BENS]

II - DO DIREITO

O artigo 610 do CPC estabelece o procedimento para o inventário e partilha de bens.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A abertura do inventário;
b) A nomeação do(a) requerente como inventariante;
c) A citação dos herdeiros e interessados;
d) A avaliação e partilha dos bens;
e) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DO ESPÓLIO].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "arrolamento-bens",
          name: "Arrolamento de Bens",
          type: "Petição Inicial",
          description: "Modelo para arrolamento de bens",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 659 e seguintes do Código de Processo Civil, requerer

ARROLAMENTO

dos bens deixados por [NOME DO DE CUJUS], [QUALIFICAÇÃO], falecido(a) em [DATA DO ÓBITO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. [NOME DO DE CUJUS] faleceu em [DATA], conforme certidão de óbito anexa.

2. Os herdeiros são maiores e capazes: [RELACIONAR OS HERDEIROS]

3. [OU: O cônjuge supérstite é o único herdeiro]

4. Há consenso entre os herdeiros quanto à partilha dos bens.

5. O patrimônio é constituído pelos seguintes bens: [RELACIONAR OS BENS]

6. O valor total do espólio é de R$ [VALOR].

II - DO DIREITO

O artigo 659 do CPC permite o arrolamento quando os herdeiros são maiores e concordam com a partilha.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) O processamento por arrolamento;
b) A citação dos interessados;
c) A homologação da partilha amigável;
d) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        }
      ]
    },
    {
      id: "protecao-incapazes",
      name: "Proteção de Incapazes",
      emoji: "🛡️",
      templates: [
        {
          id: "acao-interdicao",
          name: "Ação de Interdição",
          type: "Petição Inicial",
          description: "Modelo para ação de interdição",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 747 e seguintes do Código de Processo Civil e artigos 1.767 e seguintes do Código Civil, propor a presente

AÇÃO DE INTERDIÇÃO

em face de [NOME DO INTERDITANDO], [QUALIFICAÇÃO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente é [GRAU DE PARENTESCO] do(a) interditando(a).

2. O(a) interditando(a) sofre de [DESCRIÇÃO DA ENFERMIDADE/DEFICIÊNCIA], que o(a) torna incapaz de gerir sua pessoa e seus bens.

3. [DESCREVER O ESTADO DE SAÚDE E A INCAPACIDADE]

4. É necessária a nomeação de curador para proteger os interesses do(a) interditando(a).

5. O(a) requerente tem condições e disposição para exercer a curatela.

II - DO DIREITO

O artigo 1.767 do Código Civil estabelece os casos de interdição.

O Estatuto da Pessoa com Deficiência alterou o regime das incapacidades.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do interditando;
b) A nomeação de curador provisório;
c) A realização de perícia médica;
d) A procedência para decretar a interdição;
e) A nomeação do requerente como curador definitivo.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "acao-curatela",
          name: "Ação de Curatela",
          type: "Petição Inicial",
          description: "Modelo para ação de curatela",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 747 e seguintes do Código de Processo Civil e na Lei 13.146/2015 (Estatuto da Pessoa com Deficiência), propor a presente

AÇÃO DE CURATELA

em favor de [NOME DO CURATELADO], [QUALIFICAÇÃO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente é [GRAU DE PARENTESCO] do(a) beneficiário(a).

2. [NOME DO CURATELADO] possui [DEFICIÊNCIA/CONDIÇÃO] que compromete parcialmente sua capacidade para alguns atos da vida civil.

3. [DESCREVER A SITUAÇÃO ESPECÍFICA E A NECESSIDADE DE CURATELA]

4. A curatela é necessária apenas para [ESPECIFICAR OS ATOS].

5. O(a) requerente tem condições de exercer a curatela.

II - DO DIREITO

A Lei 13.146/2015 estabeleceu o regime da curatela como medida protetiva extraordinária.

A curatela deve ser proporcional às necessidades da pessoa.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do beneficiário;
b) A realização de avaliação multidisciplinar;
c) A nomeação de curador provisório;
d) A procedência para estabelecer curatela específica;
e) A nomeação do requerente como curador.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "alvara-judicial-menor",
          name: "Alvará Judicial para Menor",
          type: "Petição",
          description: "Modelo para alvará judicial de levantamento de valores por menor",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA DE FAMÍLIA E SUCESSÕES DA COMARCA DE _____________

[NOME DO REPRESENTANTE LEGAL], [QUALIFICAÇÃO], na qualidade de [MÃE/PAI/TUTOR] do(a) menor [NOME DO MENOR], [QUALIFICAÇÃO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.691 do Código Civil, requerer

ALVARÁ JUDICIAL

para levantamento de valores em nome do(a) menor, pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) menor [NOME] é titular de [DESCREVER O DIREITO: FGTS, seguro de vida, indenização, etc.].

2. O valor a ser levantado é de R$ [VALOR], conforme documentos anexos.

3. [DESCREVER A ORIGEM DOS VALORES E A NECESSIDADE DO LEVANTAMENTO]

4. O levantamento se destina a [FINALIDADE: sustento, educação, saúde, etc.].

5. O(a) requerente exercem o poder familiar e têm condições de administrar os valores.

II - DO DIREITO

O artigo 1.691 do Código Civil estabelece que os menores não podem receber valores sem autorização judicial.

O artigo 1.689 do Código Civil confere aos pais a administração dos bens dos filhos menores.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A expedição de alvará judicial;
b) Autorização para levantamento dos valores;
c) [SE NECESSÁRIO: Determinação para aplicação em poupança ou fundo de investimento];
d) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        }
      ]
    }
  ]
};
